import { Document, ResultFileType, ServiceNameType } from '@consigli/types';

export enum ResultDocumentOrder {
  IFC,
  REVIT,
  DRAWINGS_2D,
  REPORTS,
  ACOUSTIC_REPORT,
  FIRE_REPORT,
  COMMISSIONING_REPORT,
  VENTILATION_RATES,
  LUMINAIRE,
  STRATEGIES,
  OTHERS,
}

export enum InputDocumentOrder {
  IFC,
  SPECIFICATIONS,
}

const RESULT_FILE_TYPE_MAP: Record<ResultFileType, ResultDocumentOrder> = {
  [ResultFileType.IFC]: ResultDocumentOrder.IFC,
  [ResultFileType.REVIT]: ResultDocumentOrder.REVIT,
  [ResultFileType.DRAWINGS_2D]: ResultDocumentOrder.DRAWINGS_2D,
  [ResultFileType.REPORTS]: ResultDocumentOrder.REPORTS,
  [ResultFileType.ACOUSTIC_REPORT]: ResultDocumentOrder.ACOUSTIC_REPORT,
  [ResultFileType.FIRE_REPORT]: ResultDocumentOrder.COMMISSIONING_REPORT,
  [ResultFileType.COMMISSIONING_REPORT]: ResultDocumentOrder.COMMISSIONING_REPORT,
  [ResultFileType.VENTILATION_RATES]: ResultDocumentOrder.VENTILATION_RATES,
  [ResultFileType.STRATEGIES]: ResultDocumentOrder.STRATEGIES,
  [ResultFileType.LUMINAIRE]: ResultDocumentOrder.LUMINAIRE,
  [ResultFileType.OTHERS]: ResultDocumentOrder.OTHERS,
};

const SERVICE_TYPE_MAP: Partial<Record<ServiceNameType, ResultDocumentOrder>> = {
  [ServiceNameType.LUMINAIRE_SCHEDULE]: ResultDocumentOrder.LUMINAIRE,
};

export function getDocumentPriority(doc: Document): ResultDocumentOrder | InputDocumentOrder {
  if (doc.fileType) {
    return (
      RESULT_FILE_TYPE_MAP[doc.fileType as ResultFileType] ??
      SERVICE_TYPE_MAP[doc.fileType as ServiceNameType] ??
      ResultDocumentOrder.OTHERS
    );
  }

  if (doc.extension === '.ifc') {
    return InputDocumentOrder.IFC;
  }

  return InputDocumentOrder.SPECIFICATIONS;
}

export function sortDocumentsByType(documents: Document[]): Document[] {
  if (!documents.length) return [];

  return [...documents].sort((a, b) => {
    // First sort by document type/category
    const priorityA = getDocumentPriority(a);
    const priorityB = getDocumentPriority(b);

    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }

    // If same category, sort by name alphabetically
    return a.name.localeCompare(b.name);
  });
}
